(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cls365-carousel')) {
  class Cls365Carousel extends HTMLElement {
    connectedCallback() {
      this.total = parseInt(this.dataset.total, 10) || 0;
      if (this.total < 1) return;

      this.index = 0;
      this.tracks = Array.from(this.querySelectorAll('[data-cls365-track]'));
      this.dots = Array.from(this.querySelectorAll('[data-cls365-dot]'));
      this.current = this.querySelector('[data-cls365-current]');

      const prev = this.querySelector('[data-cls365-prev]');
      const next = this.querySelector('[data-cls365-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.cls365Dot, 10)));
      });

      this.tracks.forEach((track) => this.bindDrag(track));
      this.reveal();
      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.observer) this.observer.disconnect();
    }

    go(i) {
      if (this.total < 1) return;
      this.index = ((i % this.total) + this.total) % this.total;
      this.update();
    }

    update() {
      this.tracks.forEach((track) => {
        track.style.transform = 'translate3d(' + -this.index * 100 + '%, 0, 0)';
      });
      if (this.current) this.current.textContent = this.index + 1;
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }

    bindDrag(track) {
      let startX = 0;
      let startY = 0;
      let delta = 0;
      let active = false;
      let locked = false;

      const onDown = (e) => {
        if (e.button !== undefined && e.button !== 0) return;
        active = true;
        locked = false;
        delta = 0;
        startX = e.clientX;
        startY = e.clientY;
        track.classList.add('is-dragging');
        this.stopAutoplay();
      };

      const onMove = (e) => {
        if (!active) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (!locked) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { active = false; track.classList.remove('is-dragging'); return; }
          locked = true;
        }
        delta = dx;
        const pct = (dx / track.offsetWidth) * 100;
        track.style.transform = 'translate3d(' + (-this.index * 100 + pct) + '%, 0, 0)';
      };

      const onUp = () => {
        if (!active) return;
        active = false;
        track.classList.remove('is-dragging');
        const threshold = Math.max(40, track.offsetWidth * 0.12);
        if (delta < -threshold) this.go(this.index + 1);
        else if (delta > threshold) this.go(this.index - 1);
        else this.update();
        this.startAutoplay();
      };

      track.addEventListener('pointerdown', onDown);
      track.addEventListener('pointermove', onMove);
      track.addEventListener('pointerup', onUp);
      track.addEventListener('pointercancel', onUp);
      track.addEventListener('pointerleave', onUp);
      track.addEventListener('dragstart', (e) => e.preventDefault());
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true' || this.total < 2) return;
      this.stopAutoplay();
      const speed = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
      this.timer = setInterval(() => this.go(this.index + 1), speed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    reveal() {
      const targets = Array.from(this.querySelectorAll('[data-cls365-animate]'));
      targets.forEach((el) => {
        if (el.dataset.cls365Delay) el.style.setProperty('--cls365-delay', el.dataset.cls365Delay + 'ms');
      });

      if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('cls365-in'));
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('cls365-in');
            this.observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });

      targets.forEach((el) => this.observer.observe(el));
    }
  }

  customElements.define('cls365-carousel', Cls365Carousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
